// Dependency
import React, { useEffect } from 'react';
import {useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import useMediaQuery from '../../hooks/useMediaQuery';

// Styles
import * as styles from './instafeed.module.scss';

// Template
const InstaFeed = (props) => {
  const data = useStaticQuery(graphql`
      query {
        datoCmsInstagramFeed{
          feed{
            link
            image{
              fluid(maxWidth: 1000){
                ...GatsbyDatoCmsFluid
              }
            }
          }
        }
      }
    `);

    const isTabletOrMobile = useMediaQuery(900)

   const limit = isTabletOrMobile ? 6 : 10;

  return (
    <div className={'cd-max-width cd-dark-mode-dark'}>
      <div className={styles.cdInstaFeedText}>
        <h4>Tag it, share it.</h4>
        <div className={styles.cdInstaFeedTags}>
          <a className='cd-color-link' href="https://www.instagram.com/flowlife/" target="_blank" rel="noreferrer">@flowlife</a>
        </div>
      </div>
      <div className={styles.instaFeed} >
        {data.datoCmsInstagramFeed.feed.slice(0, limit).map((item, index) => {
          return (
            <a href={item.link} target="_blank" rel='norefferer' key={index} className={`${styles.instaFeedItem} cd-background-img`}>
              <div className={styles.instaFeedItemWrapper}>
                <Img alt="" fluid={item.image.fluid} />
              </div>
            </a>
          )
        })}
      </div>
    </div>
  );
};

export default InstaFeed;